module.exports = __webpack_public_path__ + "images/mdj/members/resume/common/common_img02-e3cbded866303cf4b51ca5b26e227bde.jpg";